export const RESOLUTIONS = [
  { code: 1, title: "Select Resolution Description" },

  { code: 11, title: "Assigned to Development" },

  { code: 30, title: "More Info Required. To Filer" },

  { code: 70, title: "Closed, data fix, cause - user error" },

  { code: 71, title: "Closed, data fix, cause - data import" },

  { code: 72, title: "Closed, data fix, cause - code error" },

  { code: 73, title: "Closed, data fix, cause - unknown" },

  { code: 74, title: "Closed, Verified by QA" },

  { code: 75, title: "Closed, Not Verified by QA" },

  { code: 84, title: "Closed, not feasible to fix" },

  { code: 91, title: "Closed, could not reproduce" },

  { code: 92, title: "Closed, not a bug" },

  { code: 96, title: "Closed, duplicate bug" },
];
